import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { CustomNavbar } from '../components';

import ProtectedRoute from './ProtectedRoute';
import AccountRouter from './AccountRouter';

import Home from '../pages/home/Home';
import Login from '../pages/login/Login';
import Store from '../pages/store/storeList/StoreList';
import Signin from '../pages/signin/Signin';
import ErrorPage from '../pages/error/ErrorPage';
import Product from '../pages/store/product/Product';
import Solutions from '../pages/solutions/Solutions';
import OurStory from '../pages/ourStory/OurStory';
import CustomScrollToTop from '../components/customScrollToTop/CustomScrollToTop';
import ForWhomMain from '../pages/forWhom/forWhomMain/ForWhomMain';
import ForWhomSection from '../pages/forWhom/forWhomSection/ForWhomSection';
import AxiosInterceptorProvider from '../components/axiosInterceptorProvider/AxiosInterceptorProvider';
import TrainingList from '../pages/training/trainingList/TrainingList';
import Training from '../pages/training/training/Training';
import EmailConfirmationValidate from '../pages/emailConfirmation/emailConfirmationValidate/EmailConfirmationValidate';
import EmailConfirmationSend from '../pages/emailConfirmation/emailConfirmationSend/EmailConfirmationSend';
import ForgotPasswordUpdate from '../pages/forgotPassword/forgotPasswordUpdate/ForgotPasswordUpdate';
import ForgotPasswordEmail from '../pages/forgotPassword/forgotPasswordEmail/ForgotPasswordEmail';

function AppRouter() {
    return (
        <Router>
            <AxiosInterceptorProvider />
            <div>
                <CustomNavbar />
                <CustomScrollToTop />

                <Routes>
                    <Route path="/" element={<Home />} />

                    <Route path="/training" element={<TrainingList />} />
                    <Route path="/training/:trainingId" element={<Training />} />

                    <Route path="/solution" element={<Solutions />} />

                    <Route path="/for_whom" element={<ForWhomMain />} />
                    <Route path="/for_whom/:sectionId" element={<ForWhomSection />} />

                    <Route path="/our_story" element={<OurStory />} />

                    <Route path="/store" element={<Store />} />
                    <Route path="/store/:projectId" element={<Product />} />

                    <Route path="/login" element={<Login />} />
                    <Route path="/signin" element={<Signin />} />
                    <Route path="/account_confirmation" element={<EmailConfirmationValidate />} />
                    <Route path="/account_confirmation_send" element={<EmailConfirmationSend />} />
                    <Route path="/forgot_password_email" element={<ForgotPasswordEmail />} />
                    <Route path="/forgot_password_update" element={<ForgotPasswordUpdate />} />

                    <Route path="/error" element={<ErrorPage />} />
                    <Route path="*" element={<ErrorPage />} />

                    <Route path="/account/*" element={
                        <ProtectedRoute><AccountRouter /></ProtectedRoute>
                    } />
                </Routes>
            </div>
        </Router>
    );
}

export default AppRouter;